import React from 'react';
import { graphql } from 'gatsby';
import ItemView from '../components/itemView';
import Layout from '../components/layout';
import SEO from '../components/seo';
// import { fetchPrice } from '../utils';

export default ({ data }) => {
  // const [price, setPrice] = useState();
  const item = data.allDataJson.nodes[0];
  const { name: title, description } = item;

  // useEffect(() => {
  //   async function getPrice() {
  //     const url = `https://growiki.hasura.app/v1/graphql`;
  //     const query = `
  //     {
  //       items(where: {name: {_eq: "${title}"}}) {
  //         name
  //         price
  //         lastUpdated
  //       }
  //     }
  //     `;
  //     fetchPrice(url, query, 'getPrice');
  //   }

  //   getPrice().then(({ data }) => {
  //     if (data?.items[0]) {
  //       const { name, price } = data.items[0];
  //       localStorage.setItem(name, JSON.stringify(price));
  //       setPrice(price);
  //     } else {
  //       let fromRecipe;

  //       const firstRecipe = JSON.parse(
  //         localStorage.getItem(recipe[0].replace(' Seed', ''))
  //       );
  //       const secondRecipe = JSON.parse(
  //         localStorage.getItem(recipe[1].replace(' Seed', ''))
  //       );

  //       fromRecipe = (firstRecipe + secondRecipe) / 4;

  //       setPrice(fromRecipe);
  //     }
  //   });

  //   return () => {
  //     const controller = new AbortController();
  //     controller.abort();
  //   };
  // }, [title, recipe]);

  return (
    <Layout>
      <SEO title={title} description={`Growtopia's ${title}: ${description}`} />
      <ItemView item={item} />
    </Layout>
  );
};

export const query = graphql`
  query($name: String!) {
    allDataJson(filter: { name: { eq: $name } }) {
      nodes {
        name
        description
        type
        rarity
        recipe
      }
    }
  }
`;
